import {
	FileImageOutlined,
	FormOutlined,
	PlusCircleFilled,
	// FormOutlined,
	// PlusCircleFilled,
} from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select, Space } from "antd";
import BlockLinkItem from "components/BlockLinkItem";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useEffect, useState } from "react";
// import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IBlock } from "types";
// import { IAddClasses } from "types";
import { getBase64Img } from "utils";

const { Option } = Select;

export const AddClassModal: React.FC<any> = ({ ...props }) => {
	const [option, setOption] = useState<string>("");
	const [classStatus, setClassStatus] = useState<boolean>(false);
	const [isActive, setIsActive] = useState<boolean>(false);
	const [isPay, setIsPay] = useState<boolean>(false);
	// const [value, setValue] = useState<string>("");
	const [imageWasAdded, setImageWasAdded] = useState<boolean>(false);
	const {
		form,
		blocks,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		setBlocks,
		setFromCreate,
		currentImgURL,
		setCourseStatus,
		setIsOpenBlock,
		setSelectedBlockId,
		setIsOpenEditBlock,
		setProcessing,
		courseId: moduleId,
		titlePage,
		onCreated
	} = props;

	const handleRegister = (values: any) => {
		setProcessing(true);
		api
			.post("/classes", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					onCreated(result.data)
					setProcessing(false);

					let message = feedback["success"] + ", " + feedback["details"];

					Swal.fire({
						icon: "success",
						text: message,
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setCourseStatus(false);
						setIsPay(false);
						setIsActive(false);
						setClassStatus(false);
						setCurrentImgURL("");
						setBlocks([]);
						// setValue("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {}, [blocks]);

	return (
		<Modal
			title={<p style={{ margin: 0 }}>{titlePage} - Cadastrar nova aula</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar aula"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = {
									...values,
									status: classStatus ? "publish" : "pending",
									image: currentImgURL,
									visibility: option,
									is_active: isActive,
									payment_required: isPay ? "pay" : "free",
									// content: value,
									order: "2",
									module_id: `${moduleId}`,
									blocks: blocks,
							  }
						handleRegister(allValues);
					})
					.catch((info: any) => {
						// console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				form.resetFields();
				setCurrentImgURL("");
				setBlocks([]);
				// setValue("");
				setCourseStatus(false);
				setIsPay(false);
				setIsActive(false);
				setClassStatus(false);
				form.resetFields();
			}}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<div className="row row-cols-12 row-cols-md-2 justify-content-center align-items-center pe-0">

					<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={setCurrentImgURL}/>
					
					<div className="mt-2">
						<Form.Item
							label="Título"
							name="title"
							rules={[
								{
									required: true,
									message: "Título necessário",
								},
							]}
						>
							<Input placeholder="Título da aula" />
						</Form.Item>
						<Form.Item
							label="Descrição"
							name="description"
							rules={[
								{
									required: true,
									message: "Descrição necessária",
								},
							]}
						>
							<Input placeholder="Descrição da aula" />
						</Form.Item>
					</div>
				</div>
				
				<div className="row">
					<div className="col-12 col-md-5">
						<Form.Item
							label="Visibilidade"
							name="visibility"
							rules={[
								{
									required: true,
									message: "Visibilidade necessária",
								},
							]}
						>
							<Select
								placeholder="Visibilidade"
								className="m-classes-modal__select"
								onChange={(e) => setOption(e)}
							>
								<Option value="public">Público</Option>
								<Option value="private">Privado</Option>
							</Select>
						</Form.Item>
					</div>
					<div className="col-12 col-md-7 row row-cols-3 pb-3 align-items-center text-center">
						<div>
							<p>Publicado</p>
							<Switch
								checked={classStatus}
								onClick={(e) => setClassStatus(e)}
							/>
						</div>
						<div>
							<p>Pago</p>
							<Switch checked={isPay} onClick={(e) => setIsPay(e)} />
						</div>
						<div>
							<p>Ativo</p>
							<Switch
								checked={isActive}
								onClick={(e) => setIsActive(e)}
							/>
						</div>
					</div>
				</div>

				<div className="m-classes-modal__blocks-content">
					<button
						type="button"
						onClick={() => {
							setIsOpenBlock(true);
							setFromCreate(true);
						}}
						className="mt-4"
					>
						<PlusCircleFilled /> Inserir Bloco de conteúdo
					</button>

					<div
						className="m-classes-modal__login-info"
						style={{
							minHeight: "300px",
							overflow: "auto",
						}}
					>
						{blocks.length === 0 && (
							<p
								className="mt-4"
								style={{
									height: "100%",
									width: "100%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								Adicione um bloco para visualizar seus respectivos items.
							</p>
						)}
						{blocks.map((block: IBlock, index: any) => {
							const label =
								block.type === "text"
									? "Textual"
									: block.type === "image"
									? "mídia - Imagem"
									: block.type === "youtube"
									? "vídeo - Youtube"
									: block.type === "vimeo"
									? "vídeo - Vimeo"
									: "mídia - Arquivo";
							return (
								<div
									key={index}
									className="m-classes-modal__blocks-content__item mt-4"
								>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
										}}
									>
										<p>
											Bloco {label} - Ordem {block.order}
										</p>
										<div className="m-classes-modal__blocks-content__item__btns">
											<Space size="small">
												<FormOutlined
													className="edit"
													onClick={() => {
														setSelectedBlockId(index);
														setIsOpenEditBlock(true);
														setFromCreate(true);
													}}
												/>
											</Space>
										</div>
									</div>
									<div className="m-classes-modal__blocks-content__item__content">
										{block.type === "text" && (
											<div
												dangerouslySetInnerHTML={{
													__html: block.content,
												}}
											></div>
										)}
										{block.type === "image" && (
											<img
												src={block.content}
												alt=""
												width="60%"
												height="100%"
											/>
										)}
										{block.type === "youtube" && (
											<BlockLinkItem block={block} />
										)}
										{block.type === "vimeo" && (
											<BlockLinkItem block={block} />
										)}
										{block.type === "archive" && (
											<a
												href={block.content}
												target="_blank"
												rel="noreferrer"
												style={{
													padding: "10px 20px",
													backgroundColor: "#f0f0f0",
													color: "#000",
													borderRadius: "5px",
												}}
											>
												Ver Arquivo
											</a>
										)}
									</div>
								</div>
							);
						})}
					</div>

				</div>
			</Form>
		</Modal>
	);
};
